export default "__VITE_ASSET__DUnXMGwQ__"